import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService, PeopleService } from '../../shared/services/index';
import { InspectionPlugin, Person } from '../../shared/models/index';
import { ContactPluginFactoryService } from './contact-plugin-factory.service';

@Injectable()
export class ContactPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    protected peopleService: PeopleService,
    private contactFactory: ContactPluginFactoryService
  ) {
    super(apiService, dataService, null, contactFactory);
  }

  public updateContact(
    inspectionId: string,
    pluginId: string,
    technicienId: string,
    regionalServiceManagerName: string,
    regionalServiceManagerTel: string,
    regionalServiceManagerEmail: string,
    localOfficeTel: string
  ): Observable<any> {
    const contact = {
      TechnicienId: technicienId,
      RegionalServiceManagerName: regionalServiceManagerName,
      RegionalServiceManagerTel: regionalServiceManagerTel,
      RegionalServiceManagerEmail: regionalServiceManagerEmail,
      LocalOfficeTel: localOfficeTel
    };
    return this._updateContact(inspectionId, pluginId, contact).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.updateInspectionContact(inspectionId, res.config);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getPeople(): Observable<Person[]> {
    return this.peopleService.getPeople();
  }

  public getPerson(id: string): Observable<Person> {
    return this.peopleService.getPerson(id);
  }

  private _updateContact(inspectionId: string, pluginId: string, contact: any): Observable<any> {
    return this.contactFactory.updateContact(inspectionId, pluginId, contact).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
